module.exports = __webpack_public_path__ + "static/media/pic-ht16.510e9657.jpg";